import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'symbolUnitNumberFormat'
})
export class SymbolUnitNumberFormatPipe implements PipeTransform {

    transform(value: number): any {
        if (isNaN(value)) {
            return value;
        }
        
        if (value < 0) {
            return parseFloat(value.toFixed(2));
        }
        if (value < 1) {
            return parseFloat(value.toFixed(2));
        }
        if (value >= 1 && value < 1000) {
            return parseFloat(value.toFixed(2));
        }
        if (value >= 1000 && value < 1000000) {
            const destructuredValue = value / 1000;
            return parseFloat(destructuredValue.toFixed(2)) + 'K';
        }
        if (value >= 1000000 && value < 1000000000) {
            const destructuredValue = value / 1000000;
            return parseFloat(destructuredValue.toFixed(2)) + 'M';
        }
        if (value >= 1000000000) {
            const destructuredValue = value / 1000000000;
            return parseFloat(destructuredValue.toFixed(2)) + 'B';
        }
        
        return value;
    }

}
